<template>
  <p-pipelines-history v-if="$hasPermission('portfolio.read')" />
  <p-not-found v-else />
</template>

<script>
import PipelinesHistory from './../components/pipelines/History.vue';
import NotFound from './../components/NotFound.vue';

export default {
  components: {
    'p-pipelines-history': PipelinesHistory,
    'p-not-found': NotFound
  }
};
</script>
